import ReactPlayer from 'react-player';
import ch4_img1 from 'assets/knowledge/ch4_img1.png';
import ch4_img2 from 'assets/knowledge/ch4_img2.png';
import ch4_img3 from 'assets/knowledge/ch4_img3.png';
import ch4_img4 from 'assets/knowledge/ch4_img4.png';
import ch4_img5 from 'assets/knowledge/ch4_img5.png';
import ch4_img6 from 'assets/knowledge/ch4_img6.png';
import ch4_img7 from 'assets/knowledge/ch4_img7.png';
import ch4_img8 from 'assets/knowledge/ch4_img8.png';
import ch4_img9 from 'assets/knowledge/ch4_img9.png';
import ch4_img10 from 'assets/knowledge/ch4_img10.png';
import ch4_img11 from 'assets/knowledge/ch4_img11.png';
import ch4_img12 from 'assets/knowledge/ch4_img12.png';
import ch4_img13 from 'assets/knowledge/ch4_img13.png';
import ch4_img14 from 'assets/knowledge/ch4_img14.png';
import ch4_img15 from 'assets/knowledge/ch4_img15.png';
import ch4_img16 from 'assets/knowledge/ch4_img16.png';
import ch4_img17 from 'assets/knowledge/ch4_img17.png';
import ch4_img18 from 'assets/knowledge/ch4_img18.png';
import ch4_img19 from 'assets/knowledge/ch4_img19.png';
import ch4_img20 from 'assets/knowledge/ch4_img20.png';
import ch4_img21 from 'assets/knowledge/ch4_img21.png';
import ch4_img22 from 'assets/knowledge/ch4_img22.png';
import ch4_img23 from 'assets/knowledge/ch4_img23.png';
import ch4_img24 from 'assets/knowledge/ch4_img24.png';
import ch4_img25 from 'assets/knowledge/ch4_img25.png';

const Chapter4 = () => {
  return <div>
  <h2>Reifenmanagement</h2>
  <ReactPlayer url="https://youtu.be/ZrlQ5OTHwnk" controls width="100%" />
  <h3>1. Verschiedene Möglichkeiten Reifen anzulegen</h3>
  <p>Reifen und Reifenmontagen können grundsätzlich auf drei verschiedenen Wegen in unsere Software hochgeladen werden:</p>
<p>
  <ul>
    <li>•	Man pflegt die Daten händisch über unsere Web App ein: ttps://app.co2opt.com/</li>
    <li>•	Die Daten werden manuell über die mobile App per Smartphone oder Tablet hochgeladen. Die App gibt es jeweils im entsprechenden App Store als Download:
Android: https://play.google.com/store/apps/details?id=com.vehicleauditapp&hl=de
IOS: https://apps.apple.com/de/app/reifen-check/id6448982249
</li>
    <li>
    •	Man sendet die PDF-Berichte für einen automatischen Upload einfach an:
upload@co2opt.com

    </li>

  </ul>
</p>

      <h3>2. Reifen auf WebApp hinzufügen</h3>
      <h3>2.1 In Fahrzeugansicht</h3>

      <p>
        Zuallererst sucht man das gewünschte Fahrzeug in der entsprechenden
        Flotte oder in der Suchzeile oben rechts.
      </p>
      <img src={ch4_img1} alt='Dashboard Ansicht1' />

      <p>
        Ist an der gewünschten Position noch kein Reifen vorhanden, klickt man
        einfach auf das Plus-Symbol.{' '}
      </p>
      <img src={ch4_img2} alt='CO2OPT Übersicht' />

      <p>
        Es öffnet sich nun ein neues Fenster. Ist bereits ein passender Reifen
        im Lager, kann man diesen in der oberen Zeile direkt suchen und
        auswählen. Dann müsste man nur noch das korrekte Montagedatum auswählen
        und auf „Anwenden“ klicken. Sollte noch kein passender Reifen im Lager
        vorhanden sein, klickt man auf die Schaltfläche „Hier“, um einen neuen
        Reifen zu erstellen.
      </p>
      <img src={ch4_img3} alt='Flottenübersicht3' />
      <p>
        Das System erstellt im nächsten Schritt automatisch eine Reifen-ID,
        welche man jedoch auch manuell abändern kann. Im unteren Abschnitt wählt
        man zuerst die gewünschte Marke aus und anschließend die gewünschte
        Produktlinie. Sollte eine bestimmte Reifenmarke oder das gewünschte
        Modell nicht vorhanden sein, können Sie dieses ebenfalls „Manuell
        eingeben“.
      </p>
      <p>
        Nachdem man die das Modell ausgewählt hat, wird automatisch die
        Profiltiefe eines Neureifens eingetragen, diese muss man ggf. anpassen.
        Als nächstes kann der Reifendruck eingetragen werden. Sollte es sich um
        einen runderneuerten oder nachgeschnittenen Reifen handeln, können Sie
        direkt daneben auch die entsprechende Checkbox auswählen. Wenn
        ausgewählt wird der Reifen dann nach der Montage mit einem R oder N
        gekennzeichnet.
      </p>
      <p>
        {' '}
        Wenn man die Profiltiefe an mehreren Rillen misst, kann man ganz unten
        auch die verschiedenen Messstellen hinzufügen, indem man den Schieber
        anklickt und dann mit dem Plus-Symbol bis zu 6 zusätzliche Felder
        hinzufügen könnt. Abschließend klickt man noch auf „Hinzufügen“.
      </p>
      <img src={ch4_img4} alt='Flottenübersicht4' />
      <p>
        Der neue Reifen ist jetzt in der oberen Zeile angegeben und liegt nun im
        Lager. Nun muss man nur noch das Montagedatum anpassen und auf
        „Anwenden“ klicken. Nun werden Ihnen zwei unterschiedliche Optionen
        angeboten.
      </p>
      <ul>
        <li>
          Man kann den Reifen an der zuvor ausgewählten Position montieren, oder
        </li>
        <li>• Man montiert den Reifen an mehreren Positionen </li>
      </ul>
      <img src={ch4_img5} alt='Flottenübersicht5' />
      <p>
        Bei "An dieser Position montieren“ ist die Aktion dann abgeschlossen und
        der Reifen ist auf der ausgewählten Position montiert. Wählt man "An
        mehreren Positionen montieren“ aus, kann man den erstellten Reifen auf
        alle Position duplizieren, die noch keinen Reifen montiert haben. Die
        oben angegebene Reifen-ID wird immer auf die zuletzt ausgewählte
        Position angewendet. Der Rest bekommt dann zufällig generierte
        Reifen-IDs. Diese Werte können jedoch auch durch ein manuelles Update
        nochmals korrigiert werden.
      </p>
      <img src={ch4_img6} alt='Flottenübersicht6' />
      <p>
        Möchte man Informationen, wie z.B. Reifennumer, für einen einzelnen
        Reifen korrigieren, klickt man einfach auf die Schaltfläche "Reifen
        aktualisieren“ und passen die gewünschten Werte an. Mit einem Klick auf
        „Aktualisieren“ werden die neuen Daten übernommen.
      </p>
      <h3>2.2 Im Inventar</h3>

      <p>
        Um Reifen direkt im Inventar zu erstellen, geht man erst auf den Reiter
        Reifenbestand.
      </p>
      <img src={ch4_img7} alt='Flottenübersicht7' />

      <p>
        Dann muss man die Flotte auswählen, in der der Reifen sich befinden
        soll. Erstellt man einen Reifen, wie in 2.1) direkt im Fahrzeug, ist der
        Reifen immer automatisch der Flotte zugeordnet, zu der auch das Fahrzeug
        gehört. Jetzt klicken wir auf die Schaltfläche „Reifen hinzufügen“.{' '}
      </p>
      <img src={ch4_img8} alt='Flottenübersicht7' />

      <p>
        Dann öffnet sich ein Fenster und man muss auswählen, ob man einen oder
        mehrere Reifen hinzufügen möchte. Als nächstes muss man die Achse
        auswählen.{' '}
      </p>

      <div className='flex gap-4 p-4'>
        <img src={ch4_img9} alt='Flottenübersicht9' />
        <img src={ch4_img10} alt='Flottenübersicht10' />
      </div>
      <p>
        Danach öffnet sich ein Fenster, das ähnlich wie das in der
        Fahrzeugansicht aussieht. Der einzige Unterschied ist, dass man hier
        erst die Reifengröße auswählen muss, damit Reifenmarken und Modelle
        angezeigt werden. Hier kann man jetzt auch noch das Produktionsdatum des
        Reifens (DOT) angeben. Der Rest ist dann ähnlich wie vorher. Nachdem man
        alle Felder ausgefüllt hat, klickt man auf „Hinzufügen“.
      </p>

      <img src={ch4_img11} alt='Flottenübersicht11' />

      <p>
        Wenn wir nun auf das Reifenlager gehen und nach der Reifen-ID suchen
        oder oben direkt nach der Reifen-ID suchen, dann liegt er jetzt im
        Lager.{' '}
      </p>
      <img src={ch4_img12} alt='Flottenübersicht12' />

      <p>
        Will man diesen Reifen jetzt auf ein Fahrzeug montieren dann muss man in
        das Fahrzeug gehen und dann die Reifen-ID oben suchen und ihn nur noch
        anklicken. Wenn er hier nicht auftauchen sollte, kann es entweder sein,
        dass die Reifengröße nicht übereinstimmt oder, dass der Reifen in einem
        anderen Lager liegt. Abschließend muss man nur noch auf „Anwenden“
        klicken.
      </p>

      <img src={ch4_img13} alt='Flottenübersicht12' />

      <h3>3. Auf der Mobilen App</h3>

      <p>
        Um einen Reifen auf der mobilen App hinzuzufügen, meldet man sich erst
        an und klickt dann auf „Überspringen“. Dann klickt man auf die Lupe und
        suchen nach dem Fahrzeugnamen{' '}
      </p>

      <div className='flex gap-4 p-4'>
        <img src={ch4_img14} alt='Flottenübersicht14' />
        <img src={ch4_img15} alt='Flottenübersicht15' />
        <img src={ch4_img16} alt='Flottenübersicht16' />
        <img src={ch4_img17} alt='Flottenübersicht17' />
      </div>
      <p>
        Nun öffnet sich die Reifenansicht. Der Unterschied zur Web App ist hier,
        dass man erst die rechte Hälfte des Fahrzeugs sieht. Um auf die andere
        Seite zu gelangen, muss man hier erst die Reifen auf der rechten Seite
        konfigurieren. Montieren wir nun einen Reifen innen links auf der
        Hinterachse. Dazu geht man mit „Weiter“ erst auf die linke Seite und
        tippt die Position einfach an. Es öffnet sich nun wieder das Fenster,
        das man auch schon von der Web App kennt. Man kann also entweder wieder
        einen Reifen, der im Lager liegt, montieren oder man fügt einen neuen
        Reifen hinzu. Wenn man auf „Neuen Reifen Hinzufügen“ klickt, dann öffnet
        sich wieder das Fenster, wo man alle Details eingeben muss. Wir wählen
        also die richtige Marke aus, das Modell, geben ggf. eine Reifennummer
        ein. Ggf gibt man eine das Produktionsdatum des Reifens oder einen
        RFID-Code ein. Dann den Druck und die Profiltiefe.
      </p>

      <div className='flex gap-4 p-4'>
        <img src={ch4_img18} alt='Flottenübersicht18' />
        <img src={ch4_img19} alt='Flottenübersicht19' />
        <img src={ch4_img20} alt='Flottenübersicht20' />
        <img src={ch4_img21} alt='Flottenübersicht21' />
      </div>

      <p>
        {' '}
        Zum Schluss kann man auch wählen, ob der Reifen nachgeschnitten oder
        runderneuert wurde. Dann klickt man auf „Anwenden“. Hier gibt es nicht
        die Möglichkeit den Reifen auf mehrere Positionen zu montieren, wie bei
        der Web App. Da die App dafür gedacht ist, dass man sie gleich in der
        Werkstatt beim Reifentausch benutzt, wird man hier nicht nach dem Datum
        gefragt. Der Reifen ist nun moniert. Klickt man auf den Reifen, kann man
        ihm im Nachhinein auch noch bearbeiten bzw. updaten.{' '}
      </p>
      <div className='flex gap-4 p-4'>
        <img src={ch4_img22} alt='Flottenübersicht22' />
        <img src={ch4_img23} alt='Flottenübersicht23' />
        <img src={ch4_img24} alt='Flottenübersicht24' />
        <img src={ch4_img25} alt='Flottenübersicht25' />
      </div>

      <p> </p>
    </div>

};

export default Chapter4;
